import React from 'react';

const LoadingSpinner = ({ message = "Loading...", size = "large" }) => {

  const sizeClasses = {
    small: "h-8 w-8 border-2",
    medium: "h-12 w-12 border-3",
    large: "h-16 w-16 border-4"
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="flex flex-col items-center justify-center space-y-4">
            <div 
              className={`animate-spin rounded-full border-blue-500 border-t-transparent ${sizeClasses[size]}`}
            ></div>
            <p className="text-lg text-gray-600 font-medium">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 